import * as Field from '@/components/ui/field'
import { createListCollection } from '@ark-ui/solid'
import { FieldInformation, SelectField } from '@components'
import type { CreateSetup } from '@hvf/contracts'
import { type FormStore, setValue } from '@modular-forms/solid'
import type { JSX } from 'solid-js'
import { fieldInformation } from '../config/fieldInformation'
import type { FormFieldType } from '../index'

interface CustomSelectProps {
  name: keyof CreateSetup
  label: string
  items: string[]
  form: FormStore<CreateSetup, undefined>
  FormField: FormFieldType
  innerTemplate?: (value: string) => JSX.Element
}

export function CustomSelect(props: CustomSelectProps) {
  return (
    <props.FormField name={props.name} type="string">
      {(field, formFieldProps) => (
        <Field.Root invalid={!!field.error}>
          <FieldInformation information={fieldInformation[props.name]}>
            <Field.Label>{props.label}</Field.Label>
          </FieldInformation>
          <SelectField
            formFieldProps={formFieldProps}
            field={field}
            collection={createListCollection({ items: props.items })}
            innerTemplate={props.innerTemplate ? props.innerTemplate : (v => v.replaceAll('_', ' '))}
            // Using 'never' safely tells TS to bypass the generic union constraint
            onChange={(e) => setValue(props.form, props.name, e.value[0] as never)}
          />
          {field.error &&
            <Field.ErrorText>
              <div>{field.error}</div>
            </Field.ErrorText>
          }
        </Field.Root>
      )}
    </props.FormField>
  )
}
